import React, { useState } from "react";
import "./About.css";
import { Link } from "react-router-dom";
import PageSEO from "../../SEO/PageSEO";
import teamImg from "../../../images/medical-team-yitalife-kampala.jpeg";
import aboutImg from "../../../images/11.jpg";

const coreValues = [
  "Respect for the principles of ethics and professionalism in all we do.",
  "Innovation, creativity and technological application to improve healthcare delivery.",
  "Teamwork, partnership and mutual respect among staff and stakeholders.",
  "Community and people-centered healthcare services and products at the heart of our work.",
];

const valueProposition = [
  "Our doctors and health workers move to the patients - not the other way around.",
  "Transition from unnecessary hospital visits to expert doctor care from the comfort of your home, institution, or workplace.",
  "Our services save you from avoidable costs: admissions, transport, traffic, and waiting time stress.",
  "Preventive Healthcare packages offer early-diagnosis screening for families, schools, companies, and rural communities.",
];

const missionPoints = [
  {
    icon: "trophy-outline",
    text: "To be the leading provider of outdoor health , home doctor and telemedicine healthcare services in Africa.",
  },
  {
    icon: "megaphone-outline",
    text: "To promote and advocate for the growth of home-based healthcare and telemedicine across Africa.",
  },
  {
    icon: "people-outline",
    text: "To advocate for equitable access to affordable, expert medical services for both urban and rural communities.",
  },
];

const timeline = [
  {
    icon: "bulb-outline",
    year: "2019",
    title: "Founded",
    detail:
      "Yita Musawo was founded with a vision of bringing Mobile Outdoor affordable healthcare Services to all Ugandans, regardless of location.",
  },
  {
    icon: "heart-outline",
    year: "2020",
    title: "COVID-19 Response",
    detail:
      '"Yita Musawo" in partnership with The Empowered Community provided - telemedicine consultations,health digital education and awareness and charity food Aid mobilization (Maize floor and Beans )reaching over 1,000 people during the pandemic.',
  },
  {
    icon: "business-outline",
    year: "2022",
    title: "Rebranding & Expansion",
    detail:
      "Yita Musawo was rebranded to Yita Medical Services and diversified its scope to include income-generating services for long-term sustainability and national expansion.",
  },
  {
    icon: "globe-outline",
    year: "2024+",
    title: "Regional Growth Prospect",
    detail:
      "Partnering with hospitals and medical centres across Uganda, with goals to expand services continent-wide.",
  },
];

const stats = [
  { num: "25", suffix: "+", label: "Medical Professionals" },
  { num: "5,000", suffix: "+", label: "Patients Served" },
  { num: "10", suffix: "", label: "Partner Facilities" },
  { num: "7", suffix: "+", label: "Years of Impact" },
];

const aboutStructuredData = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "About Yitalife - Yita Medical Services",
  description:
    "Yitalife is a service of Yita Medical Services (YMS), a registered enterprise providing equitable access to affordable, doctor-led healthcare in Uganda.",
  url: "https://www.yitalife.com/AboutUs",
  mainEntity: {
    "@type": "MedicalOrganization",
    name: "Yitalife",
    alternateName: "Yita Medical Services",
    foundingDate: "2017",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Kampala",
      addressCountry: "UG",
    },
  },
};

export default function About() {
  const [tab, setTab] = useState(0);

  return (
    <div>
      <PageSEO
        title="About Yitalife - Yita Medical Services (YMS)"
        description="Learn about Yitalife - a service of Yita Medical Services (YMS). Our mission is to bring affordable, doctor-led healthcare to every home, workplace, and community in Uganda. Est. 2017, active since 2020."
        canonical="https://www.yitalife.com/AboutUs"
        structuredData={aboutStructuredData}
      />

      {/* ── HERO ── */}
      <div className="page-hero" style={{ backgroundImage: `url(${teamImg})` }}>
        <div className="container page-hero-content">
          <h1 data-aos="fade-down">About Yitalife</h1>
          <p data-aos="fade-up" data-aos-delay="80">
            A service of Yita Medical Services (YMS); our story, vision, mission
            and values
          </p>
          <div className="page-breadcrumb">
            <Link to="/">Home</Link>
            <ion-icon
              name="chevron-forward-outline"
              style={{ fontSize: "13px" }}
            ></ion-icon>
            <span>About Us</span>
          </div>
        </div>
      </div>

      {/* ── INTRO ── */}
      <section className="about-intro-section">
        <div className="container">
          <div className="row g-5 align-items-center">
            {/* Text */}
            <div className="col-lg-7 col-md-12" data-aos="fade-right">
              <div className="badge-yita" style={{ marginBottom: "16px" }}>
                <ion-icon name="shield-checkmark-outline"></ion-icon>
                Registered Enterprise · Reg No. 80020035497111
              </div>
              <h2 style={{ fontSize: "2.2rem", marginBottom: "20px" }}>
                About Yitalife
              </h2>
              <p className="about-yms-attribution">
                <strong>Yitalife</strong> is a service of{" "}
                <strong>Yita Medical Services (YMS)</strong> - a registered
                enterprise bringing qualified, doctor-led healthcare directly to
                patients wherever they are.
              </p>
              <p>
                Yita Medical Services (YMS) was founded in 2017 with a vision of
                making affordable, high-quality healthcare accessible to all
                Ugandans - especially those in remote communities. We use part
                of our profits to support humanitarian work under TEC-Uganda.
              </p>
              <p>
                Active services began in 2020 during COVID-19. Our doctors under
                TEC-Uganda mobilised relief items and provided telemedicine
                under the banner "Yita Musawo" - benefiting over 1,000 people
                directly. Since then, we have expanded to serve patients across
                central Uganda with continental ambitions.
              </p>
              <p>
                We partner with established hospitals and medical centres to
                deliver home-based care, corporate health assessments, maternal
                care, community outreach, and specialist referrals - all under
                one professional umbrella.
              </p>

              {/* Stats */}
              <div
                className="about-stats-row"
                data-aos="fade-up"
                data-aos-delay="120"
              >
                {stats.map((s, i) => (
                  <div className="about-stat-pill" key={i}>
                    <div className="about-stat-num">
                      {s.num}
                      <span>{s.suffix}</span>
                    </div>
                    <div className="about-stat-lbl">{s.label}</div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "14px",
                  marginTop: "32px",
                  flexWrap: "wrap",
                }}
              >
                <Link to="/Services">
                  <button
                    style={{
                      background: "var(--primary)",
                      color: "white",
                      border: "none",
                      padding: "14px 28px",
                      borderRadius: "8px",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      cursor: "pointer",
                      fontSize: "14.5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    View Our Services{" "}
                    <ion-icon name="arrow-forward-outline"></ion-icon>
                  </button>
                </Link>
                <Link to="/Leadership">
                  <button
                    style={{
                      background: "transparent",
                      color: "var(--primary)",
                      border: "2px solid var(--primary)",
                      padding: "13px 28px",
                      borderRadius: "8px",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      cursor: "pointer",
                      fontSize: "14.5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <ion-icon name="people-outline"></ion-icon> Meet Our
                    Leadership
                  </button>
                </Link>
              </div>
            </div>

            {/* Image */}
            <div
              className="col-lg-5 col-md-12"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <div className="about-intro-img">
                <img
                  src={teamImg}
                  alt="Yitalife medical team - Yita Medical Services Kampala Uganda"
                  onError={(e) => {
                    e.target.src = aboutImg;
                  }}
                />
                <div className="about-intro-img-badge">
                  <div className="about-intro-img-badge-icon">
                    <ion-icon name="ribbon-outline"></ion-icon>
                  </div>
                  <div>
                    <strong>Est. 2019</strong>
                    <span>Active since 2020</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── VISION + TIMELINE ── */}
      <section className="vision-section">
        <div className="container">
          <div className="row g-5">
            {/* Vision Card */}
            <div className="col-lg-5 col-md-12" data-aos="fade-right">
              <div className="badge-yita" style={{ marginBottom: "16px" }}>
                <ion-icon name="eye-outline"></ion-icon> Our Vision
              </div>
              <div className="vision-card">
                <h3>Our Vision</h3>
                <p>
                  Communities and institutions with high regard and support for
                  good health and well-being practices - including preventive
                  medicine and affordable medical doctor services at home and in
                  the workplace.
                </p>
              </div>

              <div style={{ marginTop: "28px" }}>
                <div className="badge-yita" style={{ marginBottom: "16px" }}>
                  <ion-icon name="rocket-outline"></ion-icon> Our Mission
                </div>
                <div className="row g-3">
                  {missionPoints.map((m, i) => (
                    <div
                      className="col-12"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i * 80}
                    >
                      <div className="mission-card">
                        <div className="mission-num">{i + 1}</div>
                        <p>{m.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Timeline */}
            <div
              className="col-lg-7 col-md-12"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <div className="badge-yita" style={{ marginBottom: "16px" }}>
                <ion-icon name="time-outline"></ion-icon> Our Journey
              </div>
              <h3 style={{ fontSize: "1.8rem", marginBottom: "28px" }}>
                How We Got Here - Our Journey
              </h3>
              {timeline.map((t, i) => (
                <div
                  className="timeline-item"
                  key={i}
                  data-aos="fade-up"
                  data-aos-delay={i * 60}
                >
                  <div className="timeline-dot">
                    <ion-icon name={t.icon}></ion-icon>
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "var(--accent)",
                        fontFamily: "Inter, sans-serif",
                        textTransform: "uppercase",
                        letterSpacing: "0.8px",
                        marginBottom: "4px",
                      }}
                    >
                      {t.year}
                    </div>
                    <h5>{t.title}</h5>
                    <p>{t.detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── VALUES ── */}
      <section className="values-section">
        <div className="container">
          <h2 data-aos="fade-up">Core Values &amp; Value Proposition</h2>
          <div data-aos="fade-up" data-aos-delay="80">
            <div className="values-tab-nav">
              <button
                className={`values-tab-btn${tab === 0 ? " active" : ""}`}
                onClick={() => setTab(0)}
              >
                Core Values
              </button>
              <button
                className={`values-tab-btn${tab === 1 ? " active" : ""}`}
                onClick={() => setTab(1)}
              >
                Value Proposition
              </button>
            </div>
            <div className="values-tab-content">
              <ul className="values-list">
                {(tab === 0 ? coreValues : valueProposition).map((item, i) => (
                  <li key={i} data-aos="fade-up" data-aos-delay={i * 60}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICE AREAS ── */}
      <section className="about-service-areas">
        <div className="container">
          <div
            className="text-center"
            data-aos="fade-up"
            style={{ marginBottom: "40px" }}
          >
            <div className="badge-yita" style={{ margin: "0 auto 14px" }}>
              <ion-icon name="location-outline"></ion-icon> Service Areas
            </div>
            <h2>Where We Serve</h2>
            <p
              style={{
                maxWidth: "560px",
                margin: "0 auto",
                color: "var(--text-muted)",
              }}
            >
              Yitalife primarily serves Kampala and Central Uganda, with active
              expansion to reach patients across the whole country.
            </p>
          </div>
          <div
            className="row g-3 justify-content-center"
            data-aos="fade-up"
            data-aos-delay="80"
          >
            {[
              "Kampala",
              "Wakiso",
              "Mukono",
              "Entebbe",
              "Jinja",
              "Luwero",
              "Mpigi",
              "Mityana",
              "Masaka",
              "All of Uganda (Telemedicine)",
            ].map((area, i) => (
              <div className="col-auto" key={i}>
                <div className="service-area-pill">
                  <ion-icon name="location-outline"></ion-icon> {area}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA STRIP ── */}
      <section className="about-cta-strip">
        <div className="container">
          <div
            style={{ textAlign: "center", marginBottom: "48px" }}
            data-aos="fade-up"
          >
            <h2 style={{ fontSize: "2rem" }}>Get Started with Yitalife</h2>
            <p
              style={{
                fontSize: "18px",
                color: "var(--text-muted)",
                maxWidth: "500px",
                margin: "0 auto",
              }}
            >
              Healthcare that comes to you - wherever you are.
            </p>
          </div>
          <div className="row g-4">
            {[
              {
                icon: "calendar-outline",
                bg: "var(--primary-light)",
                color: "var(--primary)",
                title: "Book an Appointment",
                text: "Schedule a home visit or consultation at a time that suits you.",
                cta: "Book Now",
                to: "/Appointment",
              },
              {
                icon: "medkit-outline",
                bg: "#fff0f0",
                color: "var(--accent)",
                title: "Explore Services",
                text: "Browse our full range of medical services and healthcare packages.",
                cta: "View Services",
                to: "/Services",
              },
              {
                icon: "people-outline",
                bg: "#f0fff8",
                color: "var(--teal)",
                title: "Meet Our Team",
                text: "See our leadership, doctors, and board of trustees.",
                cta: "View Leadership",
                to: "/Leadership",
              },
            ].map((card, i) => (
              <div
                className="col-lg-4 col-md-6"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 80}
              >
                <div className="about-cta-card">
                  <div
                    className="about-cta-icon"
                    style={{ background: card.bg, color: card.color }}
                  >
                    <ion-icon name={card.icon}></ion-icon>
                  </div>
                  <h4>{card.title}</h4>
                  <p>{card.text}</p>
                  <Link
                    to={card.to}
                    className="about-cta-link"
                    style={{ color: card.color, borderColor: card.color }}
                  >
                    {card.cta}{" "}
                    <ion-icon name="arrow-forward-outline"></ion-icon>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
